import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {
  IDataTableAdapter,
  IRetailer,
  ITableSelectRangeEvent,
  ITableSelectionEvent,
} from '@app/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { ContentDialogGenericComponent } from '@app/shared/components';
import { ManageRetailerDialogComponent } from '../manage-retailer-dialog/manage-retailer-dialog.component';
import { RetailersService } from '@app/tvf/retailers/services/retailers/retailers.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-table-retailers',
  templateUrl: './table-retailers.component.html',
  styleUrls: ['./table-retailers.component.sass'],
})
export class TableRetailersComponent {
  columns: Array<any>;
  modalColumns: Array<any>;
  displayedColumns: Array<any>;
  dataSource = new MatTableDataSource<any>([]);
  serverPagination: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  @Input() enablePagination = true;
  @Input() enableSelection = true;
  @Input() selectedAllDefault = false;

  @Input() set dataAdapter(value: IDataTableAdapter) {
    this.buildDataAdpater(value);
  }
  @Output() rowChanged: EventEmitter<ITableSelectionEvent> =
    new EventEmitter<ITableSelectionEvent>();
  @Output() rangeChanged: EventEmitter<ITableSelectRangeEvent> =
    new EventEmitter<ITableSelectRangeEvent>();
  @Output() pageChanged = new EventEmitter<any>();
  @Output() loadRetailers = new EventEmitter<any>();
  constructor(
    private dialog: MatDialog,
    private retailersService: RetailersService,
    private toastr: ToastrService
  ) {}

  buildDataAdpater(value: IDataTableAdapter) {
    this.columns = value.columns
      .filter((c) => c.show)
      .map((column: { key: string | number; label: string; ellipsis?: number }) => ({
        columnDef: column.key,
        header: column.label,
        ellipsis: column.ellipsis,
        cell: (element: any) => `${element[column.key] ? element[column.key] : ``}`,
      }));

    this.modalColumns = value.columns;
    this.displayedColumns = this.columns.map((c) => c.columnDef);

    if (value.enableAction) {
      this.displayedColumns.push('action');
    }

    this.dataSource = new MatTableDataSource(
      value.dataSource.map((item) => ({
        ...item,
        disabledEdit: item.existsTrade,
        existsTrade: item.existsTrade ? 'Utilizado em Trade' : 'Não utilizado',
      }))
    );

    this.serverPagination = value.pagination;
  }

  handlePageEvent(e: PageEvent) {
    this.pageChanged.emit({ currentPage: e.pageIndex + 1, pageSize: e.pageSize });
  }

  async editRetailer(retailer: IRetailer) {
    const dialogRef = this.dialog.open(ManageRetailerDialogComponent, {
      minWidth: '50%',
      maxWidth: '90%',
      height: 'auto',
      panelClass: 'no-padding-dialog',
      data: { ...retailer, action: 'edit' },
    });

    const { up } = await dialogRef.afterClosed().toPromise();

    if (up) {
      this.loadRetailers.emit();
    }
  }

  deleteRetailerDialog(retailer: IRetailer) {
    const dataDialog = {
      message: `Você está excluindo o varejista ${retailer.fantasyName}. Deseja continuar?`,
      title: 'Excluir varejista',
      buttons: {
        primaryText: 'Excluir',
        primaryColor: 'warn',
        secondaryText: 'Cancelar',
        secondaryColor: 'primary',
      },
    };

    const dialogRef = this.dialog.open(ContentDialogGenericComponent, {
      data: dataDialog,
      width: '650px',
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.retailersService.deleteRetailer(retailer.retailerId).subscribe({
          next: () => {
            this.loadRetailers.emit();
            this.toastr.success('Varejista excluido com sucesso!');
          },
          error: (err) => {
            this.toastr.error(err.errors);
          },
        });
      }
    });
  }
}
